import * as ActionType from '../../constants/actionType';

export const setPoolingVolume = (tasks) => ({type: ActionType.SET_POOLING_VOLUME, tasks});

export function setPoolingReuseTip(cardId, data) {
  return {
    type: ActionType.SET_CARD_REUSE_TIP,
    cardId,
    data,
  };
}

export function addPoolingCard(cardId, cardName, cardType, reuseTips) {
  return {type: ActionType.ADD_CARD, cardId, cardName, cardType, reuseTips};
}

export default {};
